import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { WhenOverflowedDirective } from '@frontend/sports/common/ui/overflow';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { ComponentProxyDirective } from '@frontend/sports/deferred/feature/component-loader';
import { ItemComponent } from '@frontend/sports/item/feature';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { TooltipModule } from '@frontend/sports/tooltip-feature';
import { WidgetSlotComponent } from '@frontend/sports/widget/feature/slot';
import { DsButtonIcon } from '@frontend/ui/button-icon';
import { DsPill } from '@frontend/ui/pill';
import { LoginDurationComponent } from '@frontend/vanilla/features/login-duration';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxIf } from '@rx-angular/template/if';
import { NgxPopperjsModule } from 'ngx-popperjs';
import { NgScrollbarModule } from 'ngx-scrollbar';

import { BetBuilderButtonComponent } from '../bet-builder/components/button/bet-builder-button.component';
import { BetBuilderCustomMessageComponent } from '../bet-builder/components/custom-message/bet-builder-custom-message.component';
import { BetBuilderOnboardingComponent } from '../bet-builder/components/event-details-onboarding/bet-builder-onboarding-message.component';
import { BetBuilderHelpComponent } from '../bet-builder/components/help/bet-builder-help.component';
import { BetbuilderMarketListComponent } from '../bet-builder/components/market-list/bet-builder-market-list.component';
import { BetBuilderMarketComponent } from '../bet-builder/components/market/bet-builder-market.component';
import { OverlayTriggerBannerComponent } from '../bet-builder/components/overlay-trigger-banner/overlay-trigger-banner.component';
import { ErrorComponent } from '../common/error/error.component';
import { CrmPromotionContainerComponent } from '../crm-promotion-container/crm-promotion-container.component';
import { CrmPromotionModule } from '../crm-promotion/crm-promotion.module';
import { DirectivesModule } from '../directives/directives.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { EventDetailsViewModelService } from '../event-details-common/event-details-view-model.service';
import { HeaderContentComponent } from '../event-details-common/header/header-content.component';
import { EventHeaderTabsComponent } from '../event-details-common/header/tab-group/event-header-tabs.component';
import { FavouritesModule } from '../favourites/favourites.module';
import { GridModule } from '../grid/grid.module';
import { MyBetsBaseModule } from '../my-bets-base/my-bets-base.module';
import { NativeAlertsModule } from '../native-alerts/native-alerts.module';
import { NavigationCoreModule } from '../navigation-core/navigation-core.module';
import { NavigationModule } from '../navigation/navigation.module';
import { OptionGroupListComponent } from '../option-group/option-group-list.component';
import { OptionSheetViewModule } from '../option-sheet-view/option-sheet-view.module';
import { ContentBoxComponent } from '../seo/content-box.component';
import { TimerModule } from '../timers/timer.module';
import { TreeScrollDirective } from '../tree/tree-scroll.directive';
import { TreeComponent } from '../tree/tree.component';
import { BetBuilderViewComponent } from './bet-builder-view.component';
import { EventDetailsBreadcrumbComponent } from './event-details-breadcrumb.component';
import { EventDetailsModalComponent } from './event-details-modal.component';
import { EventDetailsRoutingModule } from './event-details-routing.module';
import { EventDetailsComponent } from './event-details.component';
import { EventSwitcherNavigationComponent } from './event-switcher/event-switcher-navigation/event-switcher-navigation.component';
import { EventSwitcherComponent } from './event-switcher/event-switcher/event-switcher.component';
import { EventViewSubNavigationResolve } from './event-view-subnavigation.resolve';
import { HeaderSubNavigationComponent } from './header/header-sub-navigation.component';
import { HeaderComponent } from './header/header.component';
import { LiveEventsNavigationComponent } from './live-events-navigation/live-events-navigation.component';

const declarations = [
    EventDetailsComponent,
    EventSwitcherComponent,
    EventSwitcherNavigationComponent,
    LiveEventsNavigationComponent,
    BetBuilderViewComponent,
    HeaderComponent,
    HeaderSubNavigationComponent,
    EventDetailsModalComponent,
];

const imports = [
    AutomationModule,
    CommonModule,
    CompetitionLogoComponent,
    CrmPromotionContainerComponent,
    CrmPromotionModule,
    ComponentProxyDirective,
    DirectivesModule,
    DropdownModule,
    FavouritesModule,
    GridModule,
    MyBetsBaseModule,
    NativeAlertsModule,
    NavigationCoreModule,
    NavigationModule,
    NgxPopperjsModule,
    ParticipantImageComponent,
    NgScrollbarModule,
    TimerModule,
    TooltipModule,
    AutomationModule,
    OptionSheetViewModule,
    EventHeaderTabsComponent,
    BetBuilderCustomMessageComponent,
    BetBuilderButtonComponent,
    BetBuilderHelpComponent,
    HeaderContentComponent,
    TreeComponent,
    WidgetSlotComponent,
];

@NgModule({
    imports: [
        imports,
        ErrorComponent,
        ItemComponent,
        ScrollAdapterComponent,
        WhenOverflowedDirective,
        RxIf,
        DsPill,
        BetBuilderOnboardingComponent,
        BetbuilderMarketListComponent,
        OverlayTriggerBannerComponent,
        TreeScrollDirective,
        OptionGroupListComponent,
        DsButtonIcon,
        IconCustomComponent,
        EventDetailsBreadcrumbComponent,
        LoginDurationComponent,
        BetBuilderMarketComponent,
        ContentBoxComponent,
    ],
    declarations,
})
export class EventDetailsWithoutRoutingModule {}

@NgModule({
    imports: [EventDetailsWithoutRoutingModule, EventDetailsRoutingModule],
    providers: [EventViewSubNavigationResolve, EventDetailsViewModelService],
})
export class EventDetailsModule {
    readonly eventSwitcherComponent = EventSwitcherComponent;
}
